import { useLocale } from '../../../hooks/useLocale'
import { EInvoiceStatus } from '../constants/eInvoiceStatus'
import type { EInvoiceLifecycleAction } from '../types/eInvoiceLifecycleAction'
import { useGetEInvoicingLifecycleReasons } from './useGetEInvoiceLifecycleReasons'

const STATUS_TO_LIFECYCLE_ACTION: Record<EInvoiceStatus.Disputed | EInvoiceStatus.Suspended, EInvoiceLifecycleAction> =
  {
    [EInvoiceStatus.Disputed]: 'dispute',
    [EInvoiceStatus.Suspended]: 'suspend',
  }

interface UseGetEInvoiceReasonLabel {
  status: EInvoiceStatus.Disputed | EInvoiceStatus.Suspended
  eInvoiceId: string | undefined
  reasonCode: string | null
}

export const useGetEInvoiceReasonLabel = ({ status, eInvoiceId, reasonCode }: UseGetEInvoiceReasonLabel) => {
  const { code } = useLocale()
  // Shine PA only provides reason labels in French and English
  const lang = code?.startsWith('fr') ? 'fr' : 'en'

  const lifecycleAction = STATUS_TO_LIFECYCLE_ACTION[status]

  const { data, isProcessing } = useGetEInvoicingLifecycleReasons({ lifecycleAction, eInvoiceId })

  const reasonLabel = reasonCode ? (data?.reasons?.find((r) => r.code === reasonCode)?.title[lang] ?? null) : null

  return {
    reasonLabel,
    isLoading: isProcessing && !!eInvoiceId,
  }
}
